import Footer from './Footer';
import ComponentsManager from "../../../../assets/src/js/app/controllers/ComponentsManager";


export default new class {

	constructor() {
		ComponentsManager.register('footer', Footer);
	}


};
